import React from 'react';
import { View, Text } from 'react-native';
import { HistoricalHoursByDayAverage } from '../../../components/Tables';
import DLOTable from '../../../components/Tables/DLOTable';
import { useHistoricalHoursTableData } from '../hooks';
import { TableHandlers } from '../types';

interface ScheduleTablesProps {
  dloLocationSetting: any;
  handlers: TableHandlers;
  historicalHoursSaved: boolean;
  historicalHoursSaving: boolean;
  styles: any;
}

const ScheduleTables: React.FC<ScheduleTablesProps> = ({
  dloLocationSetting,
  handlers,
  historicalHoursSaved,
  historicalHoursSaving,
  styles
}) => {
  // Use the custom hook for historical hours table data management
  const { 
    currentHistoricalHoursData, 
    handleHistoricalHoursChange 
  } = useHistoricalHoursTableData({
    historicalHoursData: dloLocationSetting.historicalHours,
    historicalHoursLoading: dloLocationSetting.historicalHoursLoading,
    historicalHoursSaved
  });

  return (
    <>
      {/* HistoricalHoursByDayAverage */}
      {dloLocationSetting.historicalHoursLoading ? (
        <View style={styles.tableLoaderContainer}>
          <Text style={styles.tableLoadingText}>Loading Historical Hours By Day Average...</Text>
        </View>
      ) : (
        <HistoricalHoursByDayAverage
          data={currentHistoricalHoursData}
          onChange={handleHistoricalHoursChange}
          onSave={() => handlers.handleSaveHistoricalHours(currentHistoricalHoursData)}
          onAddZone={handlers.handleAddZoneHistoricalHours}
          onZoneAdded={handlers.handleZoneAddedHistoricalHours}
          onRowSave={(rowId: string) => handlers.handleSaveHistoricalHoursRow(rowId, currentHistoricalHoursData)}
          onRowClear={handlers.handleClearHistoricalHoursRow}
          onRowRestore={handlers.handleRestoreHistoricalHoursRow}
          isLoading={false}
          isSaved={historicalHoursSaved}
          isSaving={historicalHoursSaving}
          context="location-settings"
          style={styles.scheduleTable}
        />
      )}

      {/* DLOTable - Shift Times */}
      {dloLocationSetting.shiftTimesLoading ? (
        <View style={styles.tableLoaderContainer}>
          <Text style={styles.tableLoadingText}>Loading Shift Times...</Text>
        </View>
      ) : (
        <DLOTable
          onSave={() => console.log('Table save action')}
          onClear={() => console.log('Table clear action')}
          data={dloLocationSetting.shiftTimes}
          loading={dloLocationSetting.shiftTimesLoading}
          error={dloLocationSetting.shiftTimesLoading ? null : dloLocationSetting.error}
          onRetry={handlers.retryShiftTimes}
          style={styles.table}
        />
      )}
    </>
  );
};

export default ScheduleTables;
